import React from 'react';
import { Container } from 'react-bootstrap';
import './BytheNumbersSection.css';

const BytheNumbersSection = () => {
  const stats = [
    {
      number: "300+",
      label: "Software Systems Delivered"
    },
    {
      number: "100%",
      label: "Customer Satisfaction"
    },
    {
      number: "20+",
      label: "AI Solutions for You"
    },
    {
      number: "30",
      label: "Years of Experience"
    }
  ];

  return (
    <section className="bythenumbers-section">
      <Container>
        <div className="stats-container">
          {stats.map((stat, index) => (
            <div key={index} className="stat-item">
              <span className="stat-number">{stat.number}</span>
              <span className="stat-label">{stat.label}</span>
            </div>
          ))}
        </div>
        
        <div className="mission-statement">
          <p>
            We partner with forward-thinking organizations to develop and 
            implement custom AI solutions that drive efficiency, 
            innovation, and growth - from strategy to deployment in 
            weeks, not years.
          </p>
        </div>
      </Container>
    </section>
  );
};

export default BytheNumbersSection;